
import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import Home from './pages/Home';
import CouponPage from './pages/CouponPage';
import Blogs from './pages/Blogs';
import BlogDetail from './pages/BlogDetail';
import EduOffers from './pages/EduOffers';
import ExamCategories from './pages/ExamCategories';
import LegalDisclaimer from './pages/LegalDisclaimer';
import VidyapeethVsOnline from './pages/VidyapeethVsOnline';
import SafetyAndTransparency from './pages/SafetyAndTransparency';

const App: React.FC = () => {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          {/* New SEO-optimized exam categories route */}
          <Route path="/pw-exam-categories" element={<ExamCategories />} />
          {/* Legacy exam categories route for backwards compatibility */}
          <Route path="/exam-categories" element={<ExamCategories />} />
          <Route path="/pw-coupon-code" element={<CouponPage pageId="pw-coupon-code" />} />
          {/* New SEO-optimized category detail routes */}
          <Route path="/pw-iit-jee-coupon-code" element={<CouponPage pageId="pw-iit-jee-coupon-code" />} />
          <Route path="/pw-neet-coupon-code" element={<CouponPage pageId="pw-neet-coupon-code" />} />
          <Route path="/pw-upsc-coupon-code" element={<CouponPage pageId="pw-upsc-coupon-code" />} />
          <Route path="/pw-gate-coupon-code" element={<CouponPage pageId="pw-gate-coupon-code" />} />
          <Route path="/pw-ssc-coupon-code" element={<CouponPage pageId="pw-ssc-coupon-code" />} />
          <Route path="/pw-banking-coupon-code" element={<CouponPage pageId="pw-banking-coupon-code" />} />
          <Route path="/pw-railway-coupon-code" element={<CouponPage pageId="pw-railway-coupon-code" />} />
          <Route path="/pw-nursing-exams-coupon-code" element={<CouponPage pageId="pw-nursing-exams-coupon-code" />} />
          <Route path="/pw-mba-coupon-code" element={<CouponPage pageId="pw-mba-coupon-code" />} />
          <Route path="/pw-ca-coupon-code" element={<CouponPage pageId="pw-ca-coupon-code" />} />
          <Route path="/pw-nda-coupon-code" element={<CouponPage pageId="pw-nda-coupon-code" />} />
          <Route path="/pw-skills-coupon-code" element={<CouponPage pageId="pw-skills-coupon-code" />} />
          <Route path="/pw-school-preparation-coupon-code" element={<CouponPage pageId="pw-school-preparation-coupon-code" />} />
          {/* Legacy category routes for backwards compatibility */}
          <Route path="/pw-jee-coupon-code" element={<CouponPage pageId="pw-iit-jee-coupon-code" />} />
          <Route path="/category/:categorySlug" element={<CouponPage />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:id" element={<BlogDetail />} />
          <Route path="/vidyapeeth-vs-online" element={<VidyapeethVsOnline />} />
          <Route path="/edu-offers" element={<EduOffers />} />
          <Route path="/safety-and-transparency" element={<SafetyAndTransparency />} />
          <Route path="/legal-disclaimer" element={<LegalDisclaimer />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Layout>
    </Router>
  );
};

export default App;
